import types from '../actionTypes';

export const addToaster = (data) => ({
  type: types.ADD_TOAST,
  data
})
